import { render, staticRenderFns } from "./MyPageHistory.vue?vue&type=template&id=4f05909a&"
import script from "./MyPageHistory.vue?vue&type=script&lang=js&"
export * from "./MyPageHistory.vue?vue&type=script&lang=js&"
import style0 from "./MyPageHistory.vue?vue&type=style&index=0&id=4f05909a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports